import { render, staticRenderFns } from "./ChangeUserPasswordComponent.vue?vue&type=template&id=a3463a4a"
import script from "./ChangeUserPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ChangeUserPasswordComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports